import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { CORES_AUTOMOTIVAS } from '../../dominio/didatico/tokens'
import { TransformacaoPeca } from './contextoDeformacao'

interface Props {
  perfil: PerfilVeiculo
  aceso?: boolean
}

/**
 * Conjunto óptico traseiro com blocos bipartidos em vermelho rubi, guia LED e luz de ré.
 */
export function LanternasVeiculo({ perfil, aceso = true }: Props) {
  const larguraLanterna = 0.36
  const alturaLanterna = 0.11
  const profundidade = 0.14
  const y = perfil.volumeTraseiro === 'hatch' ? 0.72 : perfil.cinturaY - 0.04
  const z = perfil.traseiraZ + profundidade / 2 - 0.01
  const xAfastamento = perfil.largura / 2 - larguraLanterna / 2 - 0.04

  return (
    <group>
      {[-1, 1].map((sinal) => (
        <TransformacaoPeca key={sinal} pecaId={`lanterna${sinal > 0 ? 'Esquerda' : 'Direita'}`} ancora={[sinal * xAfastamento, y, z]}>
        <group
          position={[sinal * xAfastamento, y, z]}
          rotation={[-0.04, sinal * 0.08, 0]}
        >
          {/* Carcaça traseira */}
          <mesh position={[0, 0, 0.02]}>
            <boxGeometry args={[larguraLanterna, alturaLanterna, profundidade]} />
            <meshStandardMaterial color="#0f172a" roughness={0.8} />
          </mesh>

          {/* Guia de luz LED rubi principal (luz de posição e freio) */}
          <mesh position={[-sinal * 0.02, 0, -0.04]}>
            <boxGeometry args={[larguraLanterna * 0.88, alturaLanterna * 0.45, 0.025]} />
            <meshStandardMaterial
              color={CORES_AUTOMOTIVAS.lanternaLed}
              emissive={CORES_AUTOMOTIVAS.lanternaEmissivo}
              emissiveIntensity={aceso ? 0.85 : 0.25}
              roughness={0.2}
            />
          </mesh>

          {/* Luz de ré branca / pisca no segmento inferior */}
          <mesh position={[sinal * 0.06, -alturaLanterna * 0.26, -0.045]}>
            <boxGeometry args={[larguraLanterna * 0.35, alturaLanterna * 0.28, 0.02]} />
            <meshStandardMaterial
              color={CORES_AUTOMOTIVAS.lanternaRe}
              emissive="#f1f5f9"
              emissiveIntensity={aceso ? 0.4 : 0.05}
              roughness={0.2}
            />
          </mesh>

          {/* Lente externa de acrílico vermelho rubi (otimizada) */}
          <mesh position={[0, 0, -0.06]}>
            <boxGeometry args={[larguraLanterna + 0.01, alturaLanterna + 0.01, 0.014]} />
            <meshStandardMaterial
              color={CORES_AUTOMOTIVAS.lanternaLente}
              emissive={CORES_AUTOMOTIVAS.lanternaEmissivo}
              emissiveIntensity={0.2}
              roughness={0.12}
              metalness={0.1}
              transparent
              opacity={0.65}
              depthWrite={false}
            />
          </mesh>
        </group>
        </TransformacaoPeca>
      ))}
    </group>
  )
}

